<template>
  <div>
    <PageHeader>
      <template v-slot:header>評価記号設定</template>
      <template v-slot:annotation> 評価を行う際の記号の設定をします </template>
    </PageHeader>

    <div class="text-center px-3" style="margin: 0px">
      <v-form ref="symbol_form">
        <v-row>
          <v-col
            cols="12"
            sm="6"
            md="3"
            lg="2"
            class="pt-0 pb-0 pl-3 pr-3 ma-0"
          >
            <FormInputComponent
              label="評価記号１"
              v-model="symbolMark1"
              :counter="3"
            />
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="3"
            lg="2"
            class="pt-0 pb-0 pl-3 pr-3 ma-0"
          >
            <FormInputComponent
              label="ポイント１"
              v-model="symbolPoint1"
              type="number"
              :counter="3"
              clearable
              ref="symbolPoint1"
            />
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="3"
            lg="4"
            class="pt-0 pb-0 pl-3 pr-3 ma-0"
          >
            <FormInputComponent
              label="凡例１"
              v-model="symbolExample1"
              :counter="20"
            />
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="3"
            lg="2"
            class="pt-0 pb-0 pl-3 pr-3 ma-0"
          >
            <v-select
              label="使用状態１"
              v-model="symbolExpiration1"
              item-text="label"
              item-value="value"
              :items="isActiveLabels"
              outlined
              dense
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            sm="6"
            md="3"
            lg="2"
            class="pt-0 pb-0 pl-3 pr-3 ma-0"
          >
            <FormInputComponent
              label="評価記号２"
              v-model="symbolMark2"
              :counter="3"
            />
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="3"
            lg="2"
            class="pt-0 pb-0 pl-3 pr-3 ma-0"
          >
            <FormInputComponent
              label="ポイント２"
              v-model="symbolPoint2"
              type="number"
              :counter="3"
              clearable
              ref="symbolPoint2"
            />
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="3"
            lg="4"
            class="pt-0 pb-0 pl-3 pr-3 ma-0"
          >
            <FormInputComponent
              label="凡例２"
              v-model="symbolExample2"
              :counter="20"
            />
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="3"
            lg="2"
            class="pt-0 pb-0 pl-3 pr-3 ma-0"
          >
            <v-select
              label="使用状態２"
              v-model="symbolExpiration2"
              item-text="label"
              item-value="value"
              :items="isActiveLabels"
              outlined
              dense
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            sm="6"
            md="3"
            lg="2"
            class="pt-0 pb-0 pl-3 pr-3 ma-0"
          >
            <FormInputComponent
              label="評価記号３"
              v-model="symbolMark3"
              :counter="3"
            />
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="3"
            lg="2"
            class="pt-0 pb-0 pl-3 pr-3 ma-0"
          >
            <FormInputComponent
              label="ポイント３"
              v-model="symbolPoint3"
              type="number"
              :counter="3"
              clearable
              ref="symbolPoint3"
            />
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="3"
            lg="4"
            class="pt-0 pb-0 pl-3 pr-3 ma-0"
          >
            <FormInputComponent
              label="凡例３"
              v-model="symbolExample3"
              :counter="20"
            />
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="3"
            lg="2"
            class="pt-0 pb-0 pl-3 pr-3 ma-0"
          >
            <v-select
              label="使用状態３"
              v-model="symbolExpiration3"
              item-text="label"
              item-value="value"
              :items="isActiveLabels"
              outlined
              dense
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            sm="6"
            md="3"
            lg="2"
            class="pt-0 pb-0 pl-3 pr-3 ma-0"
          >
            <FormInputComponent
              label="評価記号４"
              v-model="symbolMark4"
              :counter="3"
            />
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="3"
            lg="2"
            class="pt-0 pb-0 pl-3 pr-3 ma-0"
          >
            <FormInputComponent
              label="ポイント４"
              v-model="symbolPoint4"
              type="number"
              :counter="3"
              clearable
              ref="symbolPoint4"
            />
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="3"
            lg="4"
            class="pt-0 pb-0 pl-3 pr-3 ma-0"
          >
            <FormInputComponent
              label="凡例４"
              v-model="symbolExample4"
              :counter="20"
            />
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="3"
            lg="2"
            class="pt-0 pb-0 pl-3 pr-3 ma-0"
          >
            <v-select
              label="使用状態４"
              v-model="symbolExpiration4"
              item-text="label"
              item-value="value"
              :items="isActiveLabels"
              outlined
              dense
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            sm="6"
            md="3"
            lg="2"
            class="pt-0 pb-0 pl-3 pr-3 ma-0"
          >
            <FormInputComponent
              label="評価記号５"
              v-model="symbolMark5"
              :counter="3"
            />
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="3"
            lg="2"
            class="pt-0 pb-0 pl-3 pr-3 ma-0"
          >
            <FormInputComponent
              label="ポイント５"
              v-model="symbolPoint5"
              type="number"
              :counter="3"
              clearable
              ref="symbolPoint5"
            />
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="3"
            lg="4"
            class="pt-0 pb-0 pl-3 pr-3 ma-0"
          >
            <FormInputComponent
              label="凡例５"
              v-model="symbolExample5"
              :counter="20"
            />
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="3"
            lg="2"
            class="pt-0 pb-0 pl-3 pr-3 ma-0"
          >
            <v-select
              label="使用状態５"
              v-model="symbolExpiration5"
              item-text="label"
              item-value="value"
              :items="isActiveLabels"
              outlined
              dense
            />
          </v-col>
        </v-row>
      </v-form>
      <v-row>
        <v-col cols="6" sm="6" md="4" lg="2">
          <Button @click="erntry_confirm" color="primary">変更</Button>
        </v-col>
      </v-row>
    </div>

    <Loader :loading="loading" />

    <DialogMessage ref="dialog" />

    <ConfirmDialog
      ref="confirm"
      title="評価記号編集"
      :message="confirmMessage"
      buttonMessage="OK"
      @confirm="editSymbolInfo"
    >
    </ConfirmDialog>
  </div>
</template>

<script>
import axios from 'axios';
import config from '../../../const.js';
import message from '../../../message.js';
import moment from 'moment';
import ConfirmDialog from '@/components/Common/ConfirmMessage.vue';
import { getSessionStorageItem, convertStr } from '../../../common.js';

export default {
  components: { ConfirmDialog },

  data() {
    return {
      userInfo: {},
      loading: false,
      confirmMessage: null,
      organizationKey: null,
      symbolMark1: '',
      symbolMark2: '',
      symbolMark3: '',
      symbolMark4: '',
      symbolMark5: '',
      symbolPoint1: 0,
      symbolPoint2: 0,
      symbolPoint3: 0,
      symbolPoint4: 0,
      symbolPoint5: 0,
      symbolExample1: '',
      symbolExample2: '',
      symbolExample3: '',
      symbolExample4: '',
      symbolExample5: '',
      symbolExpiration1: '',
      symbolExpiration2: '',
      symbolExpiration3: '',
      symbolExpiration4: '',
      symbolExpiration5: '',
      editData: {
        ID: null,
        GRADE_NAME: '',
        USER_RANK: '',
        IS_ACTIVE: true,
      },
      isActiveLabels: [
        { label: config.USE_IN_NAME, value: config.USE_IN },
        { label: config.USE_STOP_NAME, value: config.USE_STOP },
      ],
    };
  },

  created() {
    const userInfo = getSessionStorageItem();
    this.userInfo = userInfo;
    this.get_symbol();
  },
  methods: {
    async get_symbol() {
      this.loading = true;

      if (this.userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        this.loading = false;
        return;
      }

      await axios
        .get(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/symbol/' +
            this.userInfo.SESSION_ID +
            '/' +
            this.userInfo.USER_ID +
            '/' +
            this.userInfo.ORGANIZATION_KEY
        )
        .then((response) => {
          // 評価記号データ取得
          const items = response.data[0];
          this.organizationKey = items.ORGANIZATION_KEY;
          this.symbolMark1 = convertStr(
            config.EMPTY_STRING,
            '',
            items.SYMBOL_MARK_1
          );
          this.symbolMark2 = convertStr(
            config.EMPTY_STRING,
            '',
            items.SYMBOL_MARK_2
          );
          this.symbolMark3 = convertStr(
            config.EMPTY_STRING,
            '',
            items.SYMBOL_MARK_3
          );
          this.symbolMark4 = convertStr(
            config.EMPTY_STRING,
            '',
            items.SYMBOL_MARK_4
          );
          this.symbolMark5 = this.symbolMark4 = convertStr(
            config.EMPTY_STRING,
            '',
            items.SYMBOL_MARK_5
          );

          this.symbolPoint1 = Number(items.SYMBOL_POINT_1);
          this.symbolPoint2 = Number(items.SYMBOL_POINT_2);
          this.symbolPoint3 = Number(items.SYMBOL_POINT_3);
          this.symbolPoint4 = Number(items.SYMBOL_POINT_4);
          this.symbolPoint5 = Number(items.SYMBOL_POINT_5);

          this.symbolExample1 = convertStr(
            config.EMPTY_STRING,
            '',
            items.SYMBOL_EXAMPLE_1
          );
          this.symbolExample2 = convertStr(
            config.EMPTY_STRING,
            '',
            items.SYMBOL_EXAMPLE_2
          );
          this.symbolExample3 = convertStr(
            config.EMPTY_STRING,
            '',
            items.SYMBOL_EXAMPLE_3
          );
          this.symbolExample4 = convertStr(
            config.EMPTY_STRING,
            '',
            items.SYMBOL_EXAMPLE_4
          );
          this.symbolExample5 = convertStr(
            config.EMPTY_STRING,
            '',
            items.SYMBOL_EXAMPLE_5
          );

          this.symbolExpiration1 = items.SYMBOL_EXPIRATION_1;
          this.symbolExpiration2 = items.SYMBOL_EXPIRATION_2;
          this.symbolExpiration3 = items.SYMBOL_EXPIRATION_3;
          this.symbolExpiration4 = items.SYMBOL_EXPIRATION_4;
          this.symbolExpiration5 = items.SYMBOL_EXPIRATION_5;
        })
        .catch((error) => {
          let errStr = '';
          if (error.response.status == 404) {
            errStr = message.MSG_INFO_ORGANIZATION_NOT_FOUND;
            this.$refs.dialog.open('info', errStr);
          } else if (error.response.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    erntry_confirm() {
      //----- 入力チェック
      if (!this.$refs.symbol_form.validate()) {
        return;
      }
      // 記号1
      if (this.symbolExpiration1 == config.USE_IN) {
        // 使用中の場合
        if (!this.symbolMark1) {
          this.$refs.dialog.open('info', this.makeSymbolMarkErrMsg('1'));
          return;
        }
        if (!this.symbolPoint1) {
          this.$refs.dialog.open('info', this.makeSymbolPointErrMsg('1'));
          return;
        }
        if (!this.symbolExample1) {
          this.$refs.dialog.open('info', this.makeSymbolExampleErrMsg('1'));
          return;
        }
      }
      // 記号2
      if (this.symbolExpiration2 == config.USE_IN) {
        // 使用中の場合
        if (!this.symbolMark2) {
          this.$refs.dialog.open('info', this.makeSymbolMarkErrMsg('2'));
          return;
        }
        if (!this.symbolPoint2) {
          this.$refs.dialog.open('info', this.makeSymbolPointErrMsg('2'));
          return;
        }
        if (!this.symbolExample2) {
          this.$refs.dialog.open('info', this.makeSymbolExampleErrMsg('2'));
          return;
        }
      }
      // 記号3
      if (this.symbolExpiration3 == config.USE_IN) {
        // 使用中の場合
        if (!this.symbolMark3) {
          this.$refs.dialog.open('info', this.makeSymbolMarkErrMsg('3'));
          return;
        }
        if (!this.symbolPoint3) {
          this.$refs.dialog.open('info', this.makeSymbolPointErrMsg('3'));
          return;
        }
        if (!this.symbolExample3) {
          this.$refs.dialog.open('info', this.makeSymbolExampleErrMsg('3'));
          return;
        }
      }
      // 記号4
      if (this.symbolExpiration4 == config.USE_IN) {
        // 使用中の場合
        if (!this.symbolMark4) {
          this.$refs.dialog.open('info', this.makeSymbolMarkErrMsg('4'));
          return;
        }
        if (!this.symbolPoint4) {
          this.$refs.dialog.open('info', this.makeSymbolPointErrMsg('4'));
          return;
        }
        if (!this.symbolExample4) {
          this.$refs.dialog.open('info', this.makeSymbolExampleErrMsg('4'));
          return;
        }
      }
      // 記号5
      if (this.symbolExpiration5 == config.USE_IN) {
        // 使用中の場合
        if (!this.symbolMark5) {
          this.$refs.dialog.open('info', this.makeSymbolMarkErrMsg('5'));
          return;
        }
        if (!this.symbolPoint5) {
          this.$refs.dialog.open('info', this.makeSymbolPointErrMsg('5'));
          return;
        }
        if (!this.symbolExample5) {
          this.$refs.dialog.open('info', this.makeSymbolExampleErrMsg('5'));
          return;
        }
      }
      // 確認ダイアログ表示
      this.confirmMessage =
        '評価記号情報を変更しますか？\n' +
        ' ※変更した評価記号情報は次の人事考課から反映されます。';
      this.$refs.confirm.open();
    },
    makeSymbolMarkErrMsg(symbolNumber) {
      let errMsg = '評価記号aが未入力です。評価記号aを入力してください。';
      return errMsg.replace(/a/g, symbolNumber);
    },
    makeSymbolPointErrMsg(symbolNumber) {
      let errMsg = 'ポイントaが未入力です。ポイントaを入力してください。';
      return errMsg.replace(/a/g, symbolNumber);
    },
    makeSymbolExampleErrMsg(symbolNumber) {
      let errMsg = '凡例aが未入力です。凡例aを入力してください。';
      return errMsg.replace(/a/g, symbolNumber);
    },
    editSymbolInfo() {
      // ローディング画像表示
      this.loading = false;
      // ユーザ情報の取得
      let userInfo = getSessionStorageItem();
      // セッションチェック
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        this.loading = false;
        return;
      }
      // 記号1
      if (this.symbolExpiration1 == config.USE_STOP) {
        this.symbolMark1 = config.EMPTY_STRING;
        this.symbolPoint1 = '0';
        this.symbolExample1 = config.EMPTY_STRING;
      }
      // 記号2
      if (this.symbolExpiration2 == config.USE_STOP) {
        this.symbolMark2 = config.EMPTY_STRING;
        this.symbolPoint2 = '0';
        this.symbolExample2 = config.EMPTY_STRING;
      }
      // 記号3
      if (this.symbolExpiration3 == config.USE_STOP) {
        this.symbolMark3 = config.EMPTY_STRING;
        this.symbolPoint3 = '0';
        this.symbolExample3 = config.EMPTY_STRING;
      }
      // 記号4
      if (this.symbolExpiration4 == config.USE_STOP) {
        this.symbolMark4 = config.EMPTY_STRING;
        this.symbolPoint4 = '0';
        this.symbolExample4 = config.EMPTY_STRING;
      }
      // 記号5
      if (this.symbolExpiration5 == config.USE_STOP) {
        this.symbolMark5 = config.EMPTY_STRING;
        this.symbolPoint5 = '0';
        this.symbolExample5 = config.EMPTY_STRING;
      }

      // 更新日時設定
      this.updateAt = moment().format('YYYYMMDDHHmmss');

      //----- 評価記号更新リクエストPOST
      axios
        .post(
          config.CONNECT_EVALUATIONS_URL + '/Evaluations/manages/symbol/edit',
          {
            SESSION_ID: userInfo.SESSION_ID,
            SESSION_USER_ID: userInfo.USER_ID,

            ORGANIZATION_KEY: this.organizationKey,
            SYMBOL_MARK_1: this.symbolMark1,
            SYMBOL_MARK_2: this.symbolMark2,
            SYMBOL_MARK_3: this.symbolMark3,
            SYMBOL_MARK_4: this.symbolMark4,
            SYMBOL_MARK_5: this.symbolMark5,

            SYMBOL_POINT_1: this.symbolPoint1,
            SYMBOL_POINT_2: this.symbolPoint2,
            SYMBOL_POINT_3: this.symbolPoint3,
            SYMBOL_POINT_4: this.symbolPoint4,
            SYMBOL_POINT_5: this.symbolPoint5,

            SYMBOL_EXAMPLE_1: this.symbolExample1,
            SYMBOL_EXAMPLE_2: this.symbolExample2,
            SYMBOL_EXAMPLE_3: this.symbolExample3,
            SYMBOL_EXAMPLE_4: this.symbolExample4,
            SYMBOL_EXAMPLE_5: this.symbolExample5,

            SYMBOL_EXPIRATION_1: this.symbolExpiration1,
            SYMBOL_EXPIRATION_2: this.symbolExpiration2,
            SYMBOL_EXPIRATION_3: this.symbolExpiration3,
            SYMBOL_EXPIRATION_4: this.symbolExpiration4,
            SYMBOL_EXPIRATION_5: this.symbolExpiration5,

            UPDATED_AT: this.updateAt,
          }
        )
        .then((response) => {
          // ローディング画像終了
          this.loading = false;

          let msgStr = '';
          if (response.status == 200) {
            msgStr = message.MSG_INFO_ORGANIZE_ENTRY_COMPLETE;
            this.$refs.dialog.open('info', msgStr);
            this.$emit('edit');
          }
        })
        .catch((error) => {
          // ローディング画像終了
          this.loading = false;

          let errStr = '';
          if (error.response.status == 400) {
            errStr = message.MSG_ERROR_SESSION_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          }
        });
    },
  },
};
</script>
